import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnTab from "@shared/components/SnTab";
import { showDialog } from "@widgets/CommonDialog";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_SAL_ISU_REG_003_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const gridApiRef1 = useRef<any>(null); // 첫 번째  그리드 Reference 변수
    const gridApiRef2 = useRef<any>(null); // 두 번째  그리드 Reference 변수
    const gridApiRef3 = useRef<any>(null);
    const gridApiRef4 = useRef<any>(null);
    const gridApiRef5 = useRef<any>(null);
    const gridApiRef6 = useRef<any>(null);
    const searchRef = useRef<any>(null);
    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);

    const [columns1, setColums1] = useState<any[]>([]);
    const [columns2, setColums2] = useState<any[]>([]);
    const [columns3, setColums3] = useState<any[]>([]);
    const [columns4, setColums4] = useState<any[]>([]);
    const [columns5, setColums5] = useState<any[]>([]);
    const [columns6, setColums6] = useState<any[]>([]);

    const [dataSource1, setDataSource1] = useState<any[]>([]);
    const [dataSource2, setDataSource2] = useState<any[]>([]);
    const [dataSource3, setDataSource3] = useState<any[]>([]);
    const [dataSource4, setDataSource4] = useState<any[]>([]);
    const [dataSource5, setDataSource5] = useState<any[]>([]);
    const [dataSource6, setDataSource6] = useState<any[]>([]);

    const [selectedTabPage, setTapPage] = useState<string>("1");
    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedRow: () =>
        selectedTabPage === "1"
          ? [
              gridApiRef1.current.getSelectedRows() || [],
              gridApiRef2.current.getSelectedRows() || [],
              gridApiRef3.current.getSelectedRows() || [],
            ] // Expose the function as part of an object
          : [
              gridApiRef4.current.getSelectedRows() || [],
              gridApiRef5.current.getSelectedRows() || [],
              gridApiRef6.current.getSelectedRows() || [],
            ],
      checkvalidity: () => {
        return "validation check";
      },
    }));

    // const getSelectedRow = () => {
    //   if (selectedTabPage === "1") {
    //     return [
    //       gridApiRef1.current.getSelectedRows() || [],
    //       gridApiRef2.current.getSelectedRows() || [],
    //       gridApiRef3.current.getSelectedRows() || [],
    //     ];
    //   } else if (selectedTabPage === "2") {
    //     return [
    //       gridApiRef4.current.getSelectedRows() || [],
    //       gridApiRef5.current.getSelectedRows() || [],
    //       gridApiRef6.current.getSelectedRows() || [],
    //     ];
    //   } else {
    //     return [[], []]; // Default case for unknown tab pages
    //   }
    // };

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_SAL_ISU_REG_003_POP_001", {});
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정

          setFormData(mergedData); // 조회조건 초기값
          setColums1(rtn.grid.grid1); // H그리드 항목 설정
          setColums2(rtn.grid.grid2); // L그리드 항목 설정
          setColums3(rtn.grid.grid3);
          setColums4(rtn.grid.grid4);
          setColums5(rtn.grid.grid5);
          setColums6(rtn.grid.grid6);
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    //#region Button Event
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const param = {
            id: "sn_sal_isu_reg_003_pop_01",
            params: searchRef.current.getFormdata(),
          };

          setDataSource1([]);
          setDataSource2([]);
          setDataSource3([]);
          setDataSource4([]);
          setDataSource5([]);
          setDataSource6([]);

          const data: any = await fnGetDataSet(param);

          if (selectedTabPage === "1") {
            setDataSource1(data[0]);
            setDataSource2(data[1] || []);
            setDataSource3(data[2] || []);

            if (data[0] && data[0].length > 0) {
              //const selectNoEst = data[0][0];
              await new Promise((resolve) => setTimeout(resolve, 50));

              gridApiRef1?.current.selectAndFocusRow(0);
            }
          } else {
            setDataSource4(data[3]);
            setDataSource5(data[4] || []);
            setDataSource6(data[5] || []);

            if (data[2] && data[2].length > 0) {
              await new Promise((resolve) => setTimeout(resolve, 50));

              gridApiRef4?.current.selectAndFocusRow(0);
            }
          }

          gridApiRef1.current?.selectAndFocusRow(0);
          gridApiRef2.current?.selectAndFocusRow(0);
          gridApiRef3.current?.selectAndFocusRow(0);
          gridApiRef4.current?.selectAndFocusRow(0);
          gridApiRef5.current?.selectAndFocusRow(0);
          gridApiRef6.current?.selectAndFocusRow(0);
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };
      fetchdatasource();
    };
    //#endregion

    //#region Event Method
    const onFocusedRowChanged1 = (event: any) => {
      const selectedRow = event; // 클릭한 행 데이터
      const selectedRowl = gridApiRef2.current.api.getSelectedNodes();
      if (selectedRow) {
        const no_io = selectedRow.no_io;
        const no_line = selectedRowl.no_line;
        const cd_item = selectedRowl.cd_item;
        gridApiRef2.current.applyFilters({ no_io: no_io });
        gridApiRef3.current.applyFilters({
          no_io: no_io,
          no_line: no_line,
          cd_item: cd_item,
        });
        gridApiRef2.current.selectAllFiltered();
        gridApiRef3.current.selectAllFiltered();
      } else {
        return;
      }
    };

    const onFocusedRowChanged2 = (event: any) => {
      const selectedRow = event;
      const selectedRowl = gridApiRef2.current.api.getSelectedNodes();

      if (selectedRow) {
        const no_io = selectedRow.no_io;
        const no_line = selectedRowl.no_line;
        const cd_item = selectedRowl.cd_item;
        gridApiRef3.current.applyFilters({
          no_io: no_io,
          no_line: no_line,
          cd_item: cd_item,
        });
        gridApiRef3.current?.selectAllFiltered();
      } else {
        return;
      }
    };

    const onFocusedRowChanged4 = (event: any) => {
      const selectedRow = event;
      const selectedRowl = gridApiRef5.current.api.getSelectedNodes();
      if (selectedRow) {
        const cd_cust = selectedRow.cd_cust;
        const cd_exch = selectedRow.cd_exch;
        const cd_fin = selectedRow.cd_fin;
        const fg_trns = selectedRow.fg_trns;
        const no_io = selectedRowl.no_io;
        const no_line = selectedRowl.no_line;
        const cd_item = selectedRowl.cd_item;

        gridApiRef5.current?.applyFilters({
          cd_cust: cd_cust,
          cd_exch: cd_exch,
          cd_fin: cd_fin,
          fg_trns: fg_trns,
        });
        gridApiRef5.current?.selectAllFiltered();

        gridApiRef6.current.applyFilters({
          no_io: no_io,
          no_line: no_line,
          cd_item: cd_item,
        });
        gridApiRef6.current?.selectAllFiltered();
      } else {
        return;
      }
    };

    const onFocusedRowChanged5 = (event: any) => {
      const selectedRow = event;
      if (selectedRow) {
        const no_io = selectedRow.no_io;
        const no_line = selectedRow.no_line;
        const cd_item = selectedRow.cd_item;

        gridApiRef6.current.applyFilters({
          no_io: no_io,
          no_line: no_line,
          cd_item: cd_item,
        });
        gridApiRef6.current?.selectAllFiltered();
      } else {
        return;
      }
    };

    const onTabChanged = (index: string) => {
      setTapPage(index);
    };

    //#endregion

    return (
      <div>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div>
          <SnTab
            titles={["출하본호별", "고객사별"]}
            width={"100%"}
            onTabChanged={onTabChanged}
            body={[
              <div style={{ height: "35vh", marginTop: "10px" }}>
                <SnGrid
                  ref={gridApiRef1}
                  columnConfig={columns1}
                  rowData={dataSource1}
                  rowSelection="single"
                  isEditable={false}
                  enableAddRow={false}
                  ischeckboxSelection={true}
                  onFocusedRowChanged={onFocusedRowChanged1}
                />
                <div className="w-full h-full flex flex-row space-x-1 flex-grow overflow-x-auto">
                  <div
                    className="h-full"
                    style={{ width: "65%", height: "70%" }}
                  >
                    <SnGrid
                      ref={gridApiRef2}
                      columnConfig={columns2}
                      rowData={dataSource2}
                      rowSelection="multiple"
                      isEditable={false}
                      enableAddRow={false}
                      ischeckboxSelection={true}
                      onFocusedRowChanged={onFocusedRowChanged2}
                    />
                  </div>
                  <div
                    className="h-full"
                    style={{ width: "35%", height: "70%" }}
                  >
                    <SnGrid
                      ref={gridApiRef3}
                      columnConfig={columns3}
                      rowData={dataSource3}
                      rowSelection="single"
                      isEditable={false}
                      enableAddRow={false}
                      ischeckboxSelection={true}
                    />
                  </div>
                </div>
              </div>,

              <div style={{ height: "35vh", marginTop: "10px" }}>
                <SnGrid
                  ref={gridApiRef4}
                  columnConfig={columns4}
                  rowData={dataSource4}
                  rowSelection="multiple"
                  isEditable={false}
                  enableAddRow={false}
                  ischeckboxSelection={true}
                  onFocusedRowChanged={onFocusedRowChanged4}
                />

                <div className="w-full h-full flex flex-row space-x-1 flex-grow overflow-x-auto">
                  <div
                    className="h-full"
                    style={{ width: "65%", height: "70%" }}
                  >
                    <SnGrid
                      ref={gridApiRef5}
                      columnConfig={columns5}
                      rowData={dataSource5}
                      rowSelection="single"
                      isEditable={false}
                      enableAddRow={false}
                      ischeckboxSelection={true}
                      onFocusedRowChanged={onFocusedRowChanged5}
                    />
                  </div>
                  <div
                    className="h-full"
                    style={{ width: "35%", height: "70%" }}
                  >
                    <SnGrid
                      ref={gridApiRef6}
                      columnConfig={columns6}
                      rowData={dataSource6}
                      rowSelection="multiple"
                      isEditable={false}
                      enableAddRow={false}
                      ischeckboxSelection={true}
                    />
                  </div>
                </div>
              </div>,
            ]}
          />
        </div>
      </div>
    );
  }
);

export default SN_SAL_ISU_REG_003_POP_001;
